var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpWidgetCard",
    [
      _c(
        "ItpBox",
        { attrs: { slot: "header", alignItems: "center" }, slot: "header" },
        [
          _c("strong", [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm._f("pgettext")("Rental Services", "RentalServices")
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("ItpButton", {
            staticClass: "ml-auto",
            attrs: {
              text: _vm._f("pgettext")(
                "Add rental service...",
                "RentalServices"
              ),
              variant: "light",
              size: "sm"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.evh_3343864469950044_clickPreventStop($event, {})
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "BListGroup",
            { staticClass: "rental__services" },
            [
              !_vm.items.length
                ? _c("BListGroupItem", [
                    _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("pgettext")("No services.", "RentalServices")
                          ) +
                          "\n      "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.sortItems(_vm.items), function(item) {
                return _c(
                  "BListGroupItem",
                  {
                    key: item.id,
                    staticClass: "d-flex flex-row align-items-start"
                  },
                  [
                    _c("UcInactive", {
                      staticClass: "mr-2",
                      attrs: { value: item.inactive }
                    }),
                    _vm._v(" "),
                    _c(
                      "ItpBox",
                      { attrs: { direction: "column" } },
                      [
                        _c(
                          "ItpBox",
                          {
                            staticClass: "mb-2",
                            attrs: { alignItems: "center", "wrap-items": "" }
                          },
                          [
                            _vm.rental == null
                              ? _c(
                                  "ItpLink",
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      to: {
                                        name: "app.rental",
                                        params: { id: item.rental.id }
                                      }
                                    }
                                  },
                                  [
                                    _c("ItpText", {
                                      attrs: {
                                        strong: "",
                                        text: item.rental.name
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.meter == null
                              ? _c("UcCompactMeterDisplay", {
                                  staticClass: "mr-2",
                                  attrs: { payload: item.meter }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "ItpText",
                              {
                                staticClass: "mr-2 font-weight-bold",
                                attrs: {
                                  strikethrough: _vm.isServiceStale(item)
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.name) +
                                    " (" +
                                    _vm._s(item.billing_unit) +
                                    ")\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("ItpLink", {
                              staticClass: "mr-2",
                              attrs: {
                                icon: _vm.$config.externalLinkIcon,
                                to: {
                                  name: "app.product",
                                  params: { id: item.service.id }
                                }
                              }
                            }),
                            _vm._v(" "),
                            item.valid_from || item.valid_to
                              ? _c("UcValidityPeriod", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    from: item.valid_from,
                                    to: item.valid_to
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "ItpBox",
                          { attrs: { alignItems: "center", "wrap-items": "" } },
                          [
                            item.meter_factor != null && item.meter_factor != 1
                              ? _c("UcBillingMultiplierBadge", {
                                  staticClass: "mr-2",
                                  attrs: { value: item.meter_factor }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.tariff_code
                              ? _c("UcTariffCodeBadge", {
                                  staticClass: "mr-2",
                                  attrs: { value: item.tariff_code }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.non_billable
                              ? _c("ItpBadge", {
                                  staticClass: "mr-2 border",
                                  attrs: {
                                    variant: "warning",
                                    text: _vm._f("pgettext")(
                                      "Non billable",
                                      "RentalService"
                                    ),
                                    "no-box-shadow": ""
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.intermediated_service
                              ? _c("ItpBadge", {
                                  staticClass: "mr-2 border",
                                  attrs: {
                                    icon: "mingcute:arrows-right-fill",
                                    text: _vm._f("pgettext")(
                                      "Intermediated service",
                                      "RentalService"
                                    ),
                                    "no-box-shadow": ""
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        item.invoice_notes
                          ? _c(
                              "ItpBox",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "DIV",
                                  { staticClass: "mx-1" },
                                  [
                                    _c("ItpIcon", {
                                      attrs: { icon: "uil:notes" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("ItpText", {
                                  attrs: {
                                    spacing: "px-1",
                                    text: item.invoice_notes,
                                    pre: ""
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "ItpBox",
                          [
                            item.notes
                              ? _c("ItpText", {
                                  attrs: { text: item.notes, pre: "" }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        item.cost_allocators &&
                        item.cost_allocators.data &&
                        item.cost_allocators.data.length
                          ? _c("UcRentalServiceCostAllocators", {
                              attrs: { service: item }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "UcDropdownMenu",
                      [
                        _c(
                          "b-dropdown-item-button",
                          {
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.evh_3475726502813997_clickPreventStop(
                                  $event,
                                  { item: item }
                                )
                              }
                            }
                          },
                          [
                            _c("ItpText", {
                              attrs: {
                                text: _vm._f("pgettext")("Edit", "Command")
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item-button",
                          {
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.evh_7286245325540822_clickPreventStop(
                                  $event,
                                  { item: item }
                                )
                              }
                            }
                          },
                          [
                            _c("ItpText", {
                              attrs: {
                                text: _vm._f("pgettext")(
                                  "Add cost allocator",
                                  "RentalServiceCostAllocators"
                                )
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }